export const ru = {
  activate: 'Активировать'
};
